import { createContext, ReactNode } from 'react';
import { api } from '../server/api';
import {
  IEvent,
  IGenerateQrCodeRequest,
  IGenerateQrCodeResponse,
} from '../interfaces/IEvent';

interface EventsContextProviderProps {
  children: ReactNode;
}

interface EventsContextProps {
  getPlayerEvents: () => Promise<IEvent[] | undefined>;
  getEventById: (
    eventId: string,
    clientId: string
  ) => Promise<IEvent | undefined>;
  getPlayerEventHistory(
    playerId: string
  ): Promise<IGenerateQrCodeResponse[] | undefined>;
  generateQrCode(
    body: IGenerateQrCodeRequest
  ): Promise<IGenerateQrCodeResponse | undefined>;
}

export const eventsContext = createContext({} as EventsContextProps);

export function EventsContextProvider(props: EventsContextProviderProps) {
  async function getPlayerEvents(): Promise<IEvent[] | undefined> {
    try {
      const response = await api.get(`/events/player`);
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('getPlayerEvents error: ', error);
    }
  }

  async function getEventById(
    eventId: string,
    clientId: string
  ): Promise<IEvent | undefined> {
    try {
      const response = await api.get(
        `/events/${eventId}?clientId=${encodeURIComponent(clientId)}`
      );
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('getEventById error: ', error);
    }
  }

  async function getPlayerEventHistory(
    playerId: string
  ): Promise<IGenerateQrCodeResponse[] | undefined> {
    try {
      const response = await api.get(`/events/player/${playerId}/validations`);
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('getPlayerEventHistory error: ', error);
    }
  }

  async function generateQrCode(
    body: IGenerateQrCodeRequest
  ): Promise<IGenerateQrCodeResponse | undefined> {
    try {
      const response = await api.post('/events/qrcode/generate', body);
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('generateQrCode error: ', error);
    }
  }

  return (
    <eventsContext.Provider
      value={{
        getEventById,
        getPlayerEvents,
        getPlayerEventHistory,
        generateQrCode,
      }}
    >
      {props.children}
    </eventsContext.Provider>
  );
}
